.dropdown-tooltip {
  z-index: 50;
}

.dropdown-content {
  font-size: 12px;
  line-height: 1.3333333333;
}

@media screen and (max-width: 979px) {
  .dropdown-content {
    padding: 0 16px 16px;
  }
}

@media screen and (min-width: 980px) {
  .dropdown-content__documents {
    display: table;
    width: 100%;
  }
}

@media screen and (min-width: 980px) {
  .dropdown-content__documents-wrapper--scroll {
    max-height: 312px;
    overflow-y: scroll;
  }
}

.dropdown-item {
  color: #626469;
  text-decoration: none;
}

@media screen and (max-width: 979px) {
  .dropdown-item {
    display: flex;
    padding-top: 16px;
    padding-bottom: 24px;
    flex-wrap: wrap;
    border-bottom: 1px solid #e7e6e6;
  }
}

@media screen and (min-width: 980px) {
  .dropdown-item {
    display: table-row;
  }
}

.dropdown-item__label {
  flex: 1 0 100%;
}

@media screen and (min-width: 980px) {
  .dropdown-item__label {
    display: table-cell;
    max-width: 640px;
    border-bottom: 1px solid #e7e6e6;
  }

  :host(:not([dir="rtl"])) .dropdown-item__label {
    padding: 16px 0 16px 16px;
  }

  :host([dir="rtl"]) .dropdown-item__label {
    padding: 16px 16px 16px 0;
  }
}

@media screen and (max-width: 979px) {
  .dropdown-item__label {
    font-size: 14px;
    line-height: 1.7142857143;
  }
}

.dropdown-item__extension {
  font-weight: 700;
}

@media screen and (max-width: 979px) {
  :host(:not([dir="rtl"])) .dropdown-item__size {
    margin-left: 16px;
  }

  :host([dir="rtl"]) .dropdown-item__size {
    margin-right: 16px;
  }
}

.dropdown-item__extension,
.dropdown-item__size {
  flex-shrink: 0;
}

@media screen and (max-width: 979px) {
  .dropdown-item__extension,
.dropdown-item__size {
    margin-top: 16px;
  }
}

@media screen and (min-width: 980px) {
  .dropdown-item__extension,
.dropdown-item__size {
    display: table-cell;
    border-bottom: 1px solid #e7e6e6;
  }

  :host(:not([dir="rtl"])) .dropdown-item__extension,
:host(:not([dir="rtl"])) .dropdown-item__size {
    padding: 16px 0 16px 32px;
  }

  :host([dir="rtl"]) .dropdown-item__extension,
:host([dir="rtl"]) .dropdown-item__size {
    padding: 16px 32px 16px 0;
  }
}

:host(:not([dir="rtl"])) .dropdown-item__action-icon {
  margin-left: 4px;
}

:host([dir="rtl"]) .dropdown-item__action-icon {
  margin-right: 4px;
}

@media screen and (min-width: 980px) {
  .dropdown-item__action-icon {
    display: table-cell;
    width: 19px;
    color: #42b4e6;
    border-bottom: 1px solid #e7e6e6;
  }

  :host(:not([dir="rtl"])) .dropdown-item__action-icon {
    padding: 16px 16px 16px 24px;
  }

  :host([dir="rtl"]) .dropdown-item__action-icon {
    padding: 16px 24px 16px 16px;
  }
}

@media screen and (min-width: 980px) {
  .dropdown-content__links {
    display: flex;
    padding-left: 16px;
    padding-right: 16px;
  }
}

.dropdown-link {
  text-decoration: none;
  outline: none;
  display: block;
  color: #42b4e6;
}

:host(:not([dir="rtl"])) .dropdown-link {
  margin: 16px auto 16px 0;
}

:host([dir="rtl"]) .dropdown-link {
  margin: 16px 0 16px auto;
}

.dropdown-link:hover {
  text-decoration: underline;
}

@media screen and (max-width: 979px) {
  .dropdown-link {
    font-size: 14px;
    line-height: 1.4285714286;
  }
}

@media screen and (min-width: 980px) {
  .dropdown-link {
    margin-bottom: 8px;
  }

  :host(:not([dir="rtl"])) .dropdown-link--download {
    margin-right: 0;
    margin-left: auto;
  }

  :host([dir="rtl"]) .dropdown-link--download {
    margin-left: 0;
    margin-right: auto;
  }

  :host(:not([dir="rtl"])) .dropdown-link--download:not(:first-child) {
    margin-left: 16px;
  }

  :host([dir="rtl"]) .dropdown-link--download:not(:first-child) {
    margin-right: 16px;
  }
}

:host(:not([dir="rtl"])) .dropdown-link__icon {
  margin-left: 4px;
}

:host([dir="rtl"]) .dropdown-link__icon {
  margin-right: 4px;
}